import { createResource } from '@frappe-ui/resources/resources.js'

export function createMyLearningsResource() {
  return createResource({
    url: 'retiora.api.learning.get_my_learnings',
    initialData: [],
    auto: true,
  })
}

export function createDashboardOverviewResource() {
  return createResource({
    url: 'retiora.api.learning.get_dashboard_overview',
    initialData: null,
    auto: true,
  })
}

export function createProgressOverviewResource() {
  return createResource({
    url: 'retiora.api.learning.get_progress_overview',
    initialData: null,
    auto: false,
  })
}

export function createLibraryLearningContentResource() {
  return createResource({
    url: 'retiora.api.learning.get_library_learning_content',
    initialData: [],
    auto: false,
  })
}

export function createLibraryFilterOptionsResource() {
  return createResource({
    url: 'retiora.api.learning.get_library_filter_options',
    initialData: { categories: [], content_types: [] },
    auto: true,
  })
}

export function createMyLearningContentResource() {
  return createResource({
    url: 'retiora.api.learning.get_my_learning_content',
    initialData: [],
    auto: false,
  })
}

export function createLibraryContentDetailResource(contentId) {
  return createResource({
    url: 'retiora.api.content_authoring.get_learning_content_detail',
    params: { content_name: contentId },
    initialData: null,
    auto: true,
  })
}

export function createStartLearningResource() {
  return createResource({
    url: 'retiora.api.learning.start_learning',
    auto: false,
  })
}

export function createPublishLearningContentResource() {
  return createResource({ url: 'retiora.api.content_authoring.publish_learning_content', auto: false })
}

export function createContentLifecycleResource(action) {
  return createResource({ url: `retiora.api.content_authoring.${action}`, auto: false })
}

export function createContentMetadataResource() {
  return createResource({ url: 'retiora.api.content_authoring.get_creation_metadata', initialData: null, auto: true })
}

export function createGenerateLearningDraftResource() {
  return createResource({ url: 'retiora.api.content_authoring.generate_learning_draft', auto: false })
}

export function createSaveLearningDraftResource() {
  return createResource({ url: 'retiora.api.content_authoring.save_learning_draft', auto: false })
}

export function createLearningDetailResource(learningId) {
  return createResource({
    url: 'retiora.api.learning.get_learning_detail',
    params: { learning_id: learningId },
    initialData: null,
    auto: true,
  })
}

export function createKnowledgeItemResource(learningId, itemId) {
  return createResource({
    url: 'retiora.api.learning.get_knowledge_item',
    params: { learning_id: learningId, item_id: itemId },
    initialData: null,
    auto: true,
  })
}

export function createActiveRecallSessionResource(learningId, practice = false) {
	return createResource({
		url: 'retiora.api.learning.get_active_recall_session',
		params: { learning_id: learningId, practice: practice ? 1 : 0 },
    initialData: [],
    auto: true,
  })
}

export function createReviewQueueResource() {
  return createResource({
    url: 'retiora.api.learning.get_review_queue',
    initialData: null,
    auto: true,
  })
}

export function createReviewSessionResource() {
  return createResource({
    url: 'retiora.api.learning.get_review_session',
    initialData: [],
    auto: false,
  })
}
